export interface Memo {
  _id?: string;
  shortName: MemoShortName | string;
  content: string;
  updatedAt?: string;
}

export enum MemoShortName {
  CatalogManagerApproval = 'catalog-manager-approval',
}
